import * as actionTypes from "../actions/actionTypes";
import _isArray from "lodash/isArray";
import _merge from "lodash/merge";
import _mergeWith from "lodash/mergeWith";
import _omit from "lodash/omit";

export default function analytics(state = {}, action) {
  switch (action.type) {
    case actionTypes.FETCH_SPACE_ANALYTICS: {
      const existingReportsSansResult = {},
        additionalProps = {};
      Object.keys(action.reports).forEach(report => {
        additionalProps[report] = {
          loading: true,
          error: null,
        };
        existingReportsSansResult[report] =
          action.reports[report].page > 1
            ? state[action.spaceId]?.[report]
            : _omit(state[action.spaceId]?.[report], ["result"]);
      });

      return {
        ...state,
        [action.spaceId]: {
          ...state[action.spaceId],
          ..._merge({}, existingReportsSansResult, action.reports, additionalProps),
        },
      };
    }
    case actionTypes.FETCH_SPACE_ANALYTICS_FAILURE: {
      const additionalProps = Object.keys(action.reports).reduce((acc, report) => {
        acc[report] = {
          loading: false,
          error: action.error,
        };
        return acc;
      }, {});

      return {
        ...state,
        [action.spaceId]: _merge({}, state[action.spaceId], action.reports, additionalProps),
      };
    }
    case actionTypes.FETCH_SPACE_ANALYTICS_SUCCESS: {
      const now = new Date().getTime(),
        additionalProps = Object.keys(action.response).reduce((acc, report) => {
          acc[report] = {
            hasMorePages:
              action.response[report]?.result?.length === action.reports?.[report]?.limit,
            loading: false,
            lastFetched: now,
          };
          return acc;
        }, {});

      const mergedReports = _mergeWith(
        {},
        state[action.spaceId],
        _merge({}, action.response, action.reports, additionalProps),
        (objValue, srcValue, key, _obj, srcObj) => {
          if (key === "result") {
            if (_isArray(objValue) && _isArray(srcValue) && srcObj.page && srcObj.page > 1) {
              return objValue.concat(srcValue);
            } else return srcValue;
          }
        }
      );
      return {
        ...state,
        [action.spaceId]: mergedReports,
      };
    }
    default:
      return state;
  }
}

// State-aware getter function
export function getReport(state, spaceId, reportName) {
  return state.analytics[spaceId]?.[reportName];
}
